<a *transloco="let t" [routerLink]="link" [class.disabled]="deactivated">{{ t(translationKey) }}</a>
